import TopNav from "../../home/components/TopNav";
import BAHero from "./components/BAHero";
import BAFeatures from "./components/BAFeatures";
import BACharts from "./components/BACharts";
import BAScenarios from "./components/BAScenarios";
import BAPricing from "./components/BAPricing";

export default function BusinessAnalyticsPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      <div className="pt-14">
        <BAHero />
        <BAFeatures />
        <BACharts />
        <BAScenarios />
        <BAPricing />
      </div>
    </div>
  );
}
